import { VFC } from 'react';

import CaseDataManagerSchemaSelect, {
  CaseDataManagerSchemaSelectProps,
} from 'dashboard/components/CaseDataManagerSchemaSelect';
import { parseHandlebarsText } from 'dashboard/lib/utils/handlebars';

export interface CaseDataManagerSchemaSelectHandlebarWrapperProps
  extends CaseDataManagerSchemaSelectProps {}

const removeHandlebars = (s: string) => {
  try {
    const handlebarValues = parseHandlebarsText(s);

    // Prevent parsing unsupported inputs like '{{multiple}} {{handlebars}}'
    const isSingleHandlebarString = handlebarValues.length === 1;

    // NB: The component will break if this returns null. If ReactSelect receives a null input, it breaks.
    const handlebarStrippedString = isSingleHandlebarString
      ? (handlebarValues[0].variableName ?? s)
      : s;
    return handlebarStrippedString;
  } catch {
    return s;
  }
};

const addHandlebars = (s: string) => {
  if (s) {
    return `{{${s}}}`;
  }
  return s;
};

const CaseDataManagerSchemaSelectHandlebarWrapper: VFC<
  CaseDataManagerSchemaSelectHandlebarWrapperProps
> = ({
  inputValue: rawInputValue,
  onValueChange,
  ...passThroughProps
}: CaseDataManagerSchemaSelectHandlebarWrapperProps) => {
  return (
    <CaseDataManagerSchemaSelect
      inputValue={removeHandlebars(rawInputValue)}
      onValueChange={(value: string) => {
        onValueChange(addHandlebars(value));
      }}
      {...passThroughProps}
    />
  );
};

export default CaseDataManagerSchemaSelectHandlebarWrapper;
